module.exports = __webpack_public_path__ + "img/60.1.64482bef.jpg";